import React from 'react';
import Dashboard from './components/Dashboard';
import './styles/darkTheme.css';

function App() {
  return (
    <div className="app">
      <Dashboard />
    </div>
  );
}

export default App;